import { FetchJsonProps, useReactQueryFetchJson } from '@apeiron/temp'
import ENV_CONFIG from '@src/config'
import { LootBoxData } from '@src/types/battlePass'

const useFetchBattlePassLootBoxJson = (props?: FetchJsonProps) => {
  const { fetchNow } = props || {}

  return useReactQueryFetchJson<LootBoxData[]>({
    fetchNow,
    path: ENV_CONFIG.JSON_FILE_NAME.BATTLE_PASS_LOOT_BOXES,
    deserialize: (response: any): LootBoxData[] => {
      return response
    }
  })
}

export default useFetchBattlePassLootBoxJson
